var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5404 3.1491C10.9631 2.72634 11.6472 2.72634 12.07 3.1491C12.4927 3.57187 12.4927 4.25595 12.07 4.67871L5.89829 10.8504C5.47553 11.2731 4.79145 11.2731 4.36869 10.8504L1.93035 8.41204C1.50759 7.98928 1.50759 7.3052 1.93035 6.88244C2.35311 6.45967 3.0372 6.45967 3.45996 6.88244L5.13075 8.55323L10.5404 3.1491Z",
    fill: "#124963"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconBlue);
export default __webpack_public_path__ + "static/media/check-icon-blue.615fdd0cfa32df89811ce678c8d04465.svg";
export { ForwardRef as ReactComponent };